import { map, removeAndAddListeners } from "../general/BuddyFuncs";

export default class FlickerEmbedHelper {
  constructor(
    params = {
      flickrIframeSelector: "",
    }
  ) {
    this.flickrIframeSelector = params.flickrIframeSelector;
    this.flickrIframes = [];

    this.maxWidth = 900;
    this.minWidth = 150;
    //out of 100
    this.aspectratio = 56;

    this.buffer = 50;
  }

  init() {
    this.flickrIframes = document.querySelectorAll(this.flickrIframeSelector);

    removeAndAddListeners(window, "resize", (e) => this.handleResizeWindow(e));

    this.setHeight();
  }

  handleResizeWindow(e) {
    this.setHeight();
  }

  calcHeight(iFrame) {
    let width = iFrame.offsetWidth;

    //check for max and min sizes
    if (width > this.maxWidth) {
      width = this.maxWidth;
    }

    if (width < this.minWidth) {
      width = this.minWidth;
    }

    //calc height
    return map(this.aspectratio, 0, 100, 0, width);
  }

  setHeight() {
    this.flickrIframes.forEach((iFrame) => {
      iFrame.style.height = `${this.calcHeight(iFrame)}px`;
    });
  }
}
